import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline, GroupLongTermDisabilityClass1Brochure } from "../../../../../assets";
import CoreGltdClass1 from "../../../../../assets/CorePlanImages/CoreGltdClass1Image.avif";

import "./gstdClassA.scss";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";

const GLTDClassA: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="gltd-class-b-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Group Long Term Disability (Class 01)</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<span>
							Designated full-time employees are automatically enrolled in the company-paid long- term
							disability benefit. This disability plan is non-contributory for participants (meaning the
							employee doesn’t have to pay for the coverage). If an employee meets disability
							requirements, the Plan pays a disability benefit of 50% of pay, with a maximum of $1,500 per
							month.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreGltdClass1} alt="Core GLTD Class 1 image" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={GroupLongTermDisabilityClass1Brochure} />
			</div>
		</div>
	);
};

export default GLTDClassA;
